import Airbrake from "../lib/airbrake"
import { current } from "../helpers";

new Airbrake({
  projectId: current.airbrake.projectId,
  projectKey: current.airbrake.projectKey,
  environment: current.app.environment,
  userId: current.user.id
}).start()
